import React from 'react';

type ImageMeta = {
  filename: string;
  tags: string[];
  url?: string;
};

export interface ImageCardProps {
  image: ImageMeta;
  onClick?: () => void;
}

const ImageCard: React.FC<ImageCardProps> = ({ image, onClick }) => {
  return (
    <div className="image-card" onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
      {image.url ? (
        <img src={image.url} alt={image.filename} />
      ) : (
        <div className="placeholder">No image</div>
      )}
    </div>
  );
};

export default ImageCard;